import { useQuery } from "@tanstack/react-query";
import { SpriteSpecification, StyleSpecification } from "maplibre-gl";

/* We download this style manually so that we can edit it, for now by adding
   our sprite into it. */

export const getMaptilerStyleJsonUrl = (
  backgroundMap: string | null,
  mapTilerApiKey: string | null
) => {
  if (!backgroundMap || !mapTilerApiKey) return null;
  return `https://api.maptiler.com/maps/${backgroundMap}/style.json?key=${mapTilerApiKey}`;
};

export function useMaptilerStyleJson(
  backgroundMap: string | null,
  mapTilerApiKey: string | null,
  includeAttribution = true,
  sprite?: SpriteSpecification
) {
  const url = getMaptilerStyleJsonUrl(backgroundMap, mapTilerApiKey);
  return useStyleJson(url, includeAttribution, sprite);
}

export const useStyleJson = (
  url: string | null,
  includeAttribution = true,
  sprite?: SpriteSpecification
) => {
  const response = useQuery<StyleSpecification>({
    queryKey: ["style.json", url],
    queryFn: async () => {
      if (!url) throw new Error("URL is required to fetch the style JSON");

      const response = await fetch(url);
      return response.json();
    },
    enabled: !!url,
  });

  if (!response.isSuccess) return null;

  const mapStyle = response.data;

  if (sprite) {
    // Add the sprite (for custom map icons) to the map style if it is provided
    mapStyle.sprite = sprite;
  }

  if (!includeAttribution) {
    delete mapStyle.metadata;
  }

  return mapStyle;
};
